import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_ARMS_02: ReviewedLibraryIdentity[] = [
  {
    "id": "library-personal-s3-supine-dumbbell-curl",
    "name": "仰卧哑铃肩伸位弯举",
    "group": "arms",
    "subCategory": "biceps",
    "equipment": "dumbbell",
    "pattern": "仰卧肩伸位肘屈",
    "legacyIds": [
      "personal-s3-supine-dumbbell-curl"
    ],
    "sourceId": "course-20261008-personal-03-04",
    "targetMuscles": [
      "肱二头肌",
      "肱肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s3-overhead-tricep",
    "name": "单臂绳索过顶臂屈伸",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "cable",
    "pattern": "单臂肩屈位肘伸",
    "legacyIds": [
      "personal-s3-overhead-tricep"
    ],
    "sourceId": "course-20261008-personal-03-05",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s3-internal-rotation-curl",
    "name": "坐姿绳索内旋位弯举",
    "group": "arms",
    "subCategory": "biceps",
    "equipment": "cable",
    "pattern": "坐姿肩内旋位肘屈",
    "legacyIds": [
      "personal-s3-internal-rotation-curl"
    ],
    "sourceId": "course-20261008-personal-03-06",
    "targetMuscles": [
      "肱二头肌",
      "肱肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-elbow-extension-tricep",
    "name": "徒手肘屈伸",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "bodyweight",
    "pattern": "徒手肘伸",
    "legacyIds": [
      "fanjue-elbow-extension-tricep"
    ],
    "sourceId": "course-20261008-fanjue-plan-08-03",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-bent-barbell-curl",
    "name": "俯身杠铃弯举",
    "group": "arms",
    "subCategory": "biceps",
    "equipment": "barbell",
    "pattern": "俯身杠铃肘屈",
    "legacyIds": [
      "fanjue-bent-barbell-curl"
    ],
    "sourceId": "course-20261008-fanjue-plan-14-04",
    "targetMuscles": [
      "肱二头肌",
      "肱肌"
    ],
    "evidence": "新源为坐姿绳索弯举，不以相似名称或目标肌群伪合并，标准库保留待补"
  },
  {
    "id": "library-fanjue-single-arm-cable-tricep",
    "name": "单臂绳索下压",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "cable",
    "pattern": "单臂绳索肘伸",
    "legacyIds": [
      "fanjue-single-arm-cable-tricep"
    ],
    "sourceId": "course-20261008-fanjue-plan-14-02",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-straight-bar-tricep",
    "name": "直杆三头下压",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "cable",
    "pattern": "站姿直杆肘伸",
    "legacyIds": [
      "fanjue-straight-bar-tricep"
    ],
    "sourceId": "course-20261008-fanjue-plan-14-03",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-cable-hammer-curl",
    "name": "绳索锤式弯举",
    "group": "arms",
    "subCategory": "biceps",
    "equipment": "cable",
    "pattern": "对握绳索肘屈",
    "legacyIds": [
      "fanjue-cable-hammer-curl"
    ],
    "sourceId": "course-20261008-fanjue-plan-14-06",
    "targetMuscles": [
      "肱肌",
      "肱桡肌",
      "肱二头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
